import { render, staticRenderFns } from "./ReservationsEdit.vue?vue&type=template&id=a38f24c0&scoped=true"
import script from "./ReservationsEdit.vue?vue&type=script&lang=js"
export * from "./ReservationsEdit.vue?vue&type=script&lang=js"
import style0 from "./ReservationsEdit.vue?vue&type=style&index=0&id=a38f24c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38f24c0",
  null
  
)

export default component.exports